export default {"src":"/_next/static/image/public/images/icons3/1.bbab10f24bbb291a9583a165637025ca.svg","height":72,"width":72};